import { Box, Grid, Typography } from '@mui/material';
// import { Box, Button, Grid, Typography } from '@mui/material';
import FormsPopup from '../../common/FormsPopup/FormsPopup';
import UserAvatar from '../../common/UserAvatar/UserAvatar';
import styles from './styles';
import { ViewPartnerProps } from './types';

const ViewPartner = ({ setViewPartner, viewPartner, rowPartnerData }: ViewPartnerProps) => {
    return (
        <FormsPopup
            id="view_selected_partner"
            open={viewPartner}
            title="Selected Partner"
            textAlign="left"
            handleClose={() => setViewPartner(false)}
            width={662}
        >
            <>
                <Box>
                    <Typography component="div" sx={styles.subHeadText}>
                        Inform all requested information below to create a new partner.Once confirmed, new members will
                        be allowed to register
                    </Typography>
                </Box>
                <Box component="form" noValidate id="partner-details">
                    <Grid container spacing={2} sx={styles.container}>
                        <Grid item xs={6}>
                            <Typography component="div" sx={{ display: 'flex' }}>
                                <UserAvatar
                                    name={rowPartnerData?.name || ''}
                                    source={
                                        rowPartnerData?.logoUrl && rowPartnerData?.logoUrl !== 'null'
                                            ? rowPartnerData?.logoUrl
                                            : ''
                                    }
                                    size={50}
                                    radius="8px"
                                    fontSize={20}
                                />
                                <Typography component="div" sx={styles.partnerName}>
                                    <Typography sx={styles.partnerLable}>Complete Name</Typography>
                                    <Typography sx={styles.partnerValue}>{rowPartnerData?.name}</Typography>
                                </Typography>
                            </Typography>

                            <Typography sx={styles.partnerLable}>Email</Typography>
                            <Typography sx={styles.partnerValue}>{rowPartnerData?.email}</Typography>

                            <Typography sx={styles.partnerLable}>Partner Unique Id</Typography>
                            <Typography sx={styles.uniqueIdValue}>{rowPartnerData?.uniqueId}</Typography>

                            {/* <Button id="resend_unique_id" variant="text" sx={styles.sendUniqueId}>
                                Resend Unique Id To Members
                            </Button> */}
                        </Grid>

                        <Grid item xs={6} />
                    </Grid>
                </Box>
            </>
        </FormsPopup>
    );
};
export default ViewPartner;
